module.exports = __webpack_public_path__ + "img/purple_plexus_wide.7f6e0432.png";